import { ORG_COOKIE_KEY, tokenKey, permissionKeys } from 'utils/constants';
import { useAuth0 } from '@auth0/auth0-react';
import { getUserCurrentUser } from 'api/userApi';
import { orgAction, userAction } from '../redux/actions';
import { useDispatch } from 'react-redux';
import { getCookie, deleteCookie } from 'utils/cookie';
import { cloneDeep, flattenDeep, get, isEmpty, map, orderBy } from 'lodash';
import { setOrgCookie, getOrganizations } from 'api/organizationApi';

const useUser = () => {
  const { logout } = useAuth0();
  const dispatch = useDispatch();

  const fetchCurrentUser = async () => {
    const { data } = await getUserCurrentUser();

    const checkPlatformAdmin = flattenDeep(map(data.roles, r => r.permissions)).includes(permissionKeys.PLATFORM_ADMIN);
    if (checkPlatformAdmin) {
      const myOrgs = cloneDeep(data.organizations);
      const fullOrgs = get(await getOrganizations(), 'data.entities', []);
      data.organizations = fullOrgs.map((org: any) => myOrgs?.find((myOrg: any) => org.id === myOrg.id) || org);
    }
    data.organizations = orderBy(data.organizations, 'created', 'desc');
    const organizations = data.organizations;
    const organizationDefault = localStorage.getItem(ORG_COOKIE_KEY);
    if (!organizations || isEmpty(organizations)) {
      deleteCookie(ORG_COOKIE_KEY);
    } else if (!organizationDefault || !organizations.find((o: any) => o.id === organizationDefault)) {
      await handleSetTookie(organizations[0].id);
    } else {
      await handleSetTookie(organizationDefault);
    }
    dispatch(userAction.setUserInfo(data));
  };

  const handleLogout = () => {
    deleteCookie(tokenKey);
    localStorage.removeItem(ORG_COOKIE_KEY);
    logout({ returnTo: `${window.location.origin}` });
  };

  const handleSetTookie = async (organizationId: any) => {
    await setOrgCookie(organizationId);
    localStorage.setItem(ORG_COOKIE_KEY, organizationId);
    dispatch(orgAction.setOrgCookie(organizationId));
  };

  return {
    handleLogout,
    fetchCurrentUser,
    handleSetTookie,
  };
};

export default useUser;
